import { ChangeDetectionStrategy, Component, input, Input, output } from '@angular/core';
import { NavItem } from '@libs/models/nav-item.interface';
import { IContact } from '@libs/models/models';
import { EnvironmentType } from '@libs/models/environment.type';
import { environment } from '@libs/environment';
import { Loan } from '@libs/models/loan.model';

@Component({
  selector: 'app-header-navigation',
  templateUrl: `./templates/${environment.name}/page.html`,
  styleUrls: [`./templates/${environment.name}/style.sass`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderNavigationComponent {
  @Input()
  public navItems: NavItem[] = [];

  @Input()
  public active: boolean = false;

  @Input()
  public isMobile: boolean = false;

  @Input()
  public isMenu: boolean = false;

  @Input()
  public isWebSite: boolean = false;

  @Input()
  public isLogged: boolean;

  @Input()
  public phones: IContact[] = [];

  @Input()
  public env: EnvironmentType;

  @Input()
  public langPath: string;
  public payment = input<{visible: boolean, loan: Loan}>();
  public readonly hamburgerEvent = output<void>();
  public readonly logoutEvent = output<void>();
  public readonly removeAccountEvent = output<void>();

  public openMenu(): void {
    this.hamburgerEvent.emit();
  }

  public itemEventHandler(): void {
    this.hamburgerEvent.emit();
  }

  public logoutHandler(): void {
    this.logoutEvent.emit();
  }

  public removingAccountHandler(): void {
    this.removeAccountEvent.emit();
  }
}
